import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useFormContext } from 'react-hook-form';
import { FormInput, NeuroMessage, useNeuroState, useProduct } from "@ignitesales/neuro-application";

const ProductionSelection = ({ products }) => {
    const { setValue } = useFormContext();
    const [hasError, setHasError] = useState(false);
    const { productCart } = useNeuroState();
    useEffect(() => {
        if(productCart?.size !== 0) {
            setValue('productSelected', 'test');
            setHasError(false);
        } 
        else {
            setValue('productSelected', undefined);
            setHasError(true);
        }
    }, [productCart]);

    const componentClass = 'product-selection';
    const productSelectedField = {
        name: 'productSelected',
        type: 'button',
        required: true
    };
    
    const renderProducts = () => products?.map( product => {
        const {
            isSelected,
            name,
            onSelectClick,
        } = useProduct(product);
        const classes = classnames(`${componentClass}__product`, { active: isSelected });
        const onClick = e => {
            onSelectClick();
            e.preventDefault();
        }
        return <button key={name} className={classes} onClick={onClick}>{name}</button>
    });
    const classes = classnames(`${componentClass}__container`, { 'error': hasError });
    return <section className={classes}>
        <div className={`${componentClass}__header`}><NeuroMessage id="product.productSelectionHeader" /></div>
        <div className={`${componentClass}__product-list-label`}><NeuroMessage id="product.productSelectionLabel" /></div>
        <div className={`${componentClass}__product-list`}>
            {renderProducts()}
            {<FormInput formId="contactMeForm" {...productSelectedField} />}
        </div>
    </section>;
} 

export default ProductionSelection;